import { FC } from 'react';
import { Form, Table, Typography } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationCollateral } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type VisitReportCollateralForm = {
	lists: OfficeObservationCollateral<'payload'>[];
};

const FBDHVisitReportOfficeCollateralUnit: FC = () => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { collateral } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReportCollateralForm>();

	return (
		<Form.Provider>
			<Typography.Title level={3}>
				Detail Unit yang Akan Diagunkan
			</Typography.Title>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists: collateral?.collaterals ?? [],
					} as VisitReportCollateralForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReportCollateralForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								scroll={{
									x: 1200,
								}}
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										render: (_, __, index) => index + 1,
										width: 1,
										align: 'center',
									},
									{
										title: 'Jenis Agunan',
										render: (_, record) => record.collateralType ?? '-',
									},
									{
										title: 'Merk/Tipe Serta Kapasitas',
										render: (_, record) => record.brandTypeAndCapacity ?? '-',
									},
									{
										title: 'Tahun Perakitan',
										render: (_, record) => record.yearOfAssembly ?? '-',
									},
									{
										title: 'Kepemilikan',
										render: (_, record) => record.ownership ?? '-',
									},
									{
										title: 'Hour/Meter',
										render: (_, record) => record.hoursMeters ?? '-',
									},
									{
										title: 'Kondisi Fisik',
										render: (_, record) => record.physicalCondition ?? '-',
									},
									{
										title: 'Kondisi Fungsi',
										render: (_, record) => record.functionCondition ?? '-',
									},
									{
										title: 'Keterangan (Jika Ada)',
										render: (_, record) => record.additionalInformation ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
			</Form>
		</Form.Provider>
	);
};

export default FBDHVisitReportOfficeCollateralUnit;
